var window = require('global/window');

var Context = window.AudioContext || window.webkitAudioContext;
if (Context) module.exports = new Context;



//////////////////
// WEBPACK FOOTER
// ./~/audio-context/index.js
// module id = 49
// module chunks = 0